@import 'styles/mixins';
@import 'styles/mixins';
@import 'styles/variables';

.group {
  display: flex;
  align-items: center;
  gap: 10px;
  align-self: stretch;
}
